import { urlLang } from './Language';

export let BASE_URL = process.env.PUBLIC_URL + (urlLang() ? `/${urlLang()}` : "")
export let SCHEDULE = BASE_URL + "/schedule";
export let PRODUCTS = BASE_URL + "/products";
export let LOCATION = BASE_URL + "/location";
export let CONTACTS = BASE_URL + "/contacts";
export let NEWS = BASE_URL + "/news";